<button type="button"
  class="btn btn-link help-panel-trigger p-0 border-0"
  title="Ayuda de esta pantalla"
  (click)="open(helpContent)">
  <i class="fa fa-circle-question" style="font-size: 11px;"></i>
</button>

<ng-template #helpContent let-offcanvas>
  <div class="offcanvas-header border-bottom">
    <h5 class="offcanvas-title mb-0">
      <i class="fa fa-circle-question me-2 text-info"></i>
      {{ article()?.title || 'Ayuda' }}
    </h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss()"></button>
  </div>
  <div class="offcanvas-body">
    @if (loading()) {
      <p class="text-muted">Cargando…</p>
    } @else if (notFound()) {
      <p class="text-muted mb-2">Sin ayuda para esta pantalla.</p>
      <p class="small text-muted mb-3">
        Ruta: <code>{{ currentPath() || '(inicio)' }}</code>
      </p>
      @if (canManageHelp()) {
        <a class="btn btn-sm btn-outline-primary" routerLink="/configuracion/ayuda" (click)="offcanvas.dismiss()">
          Ir al mantenedor de ayuda
        </a>
      }
    } @else if (article(); as a) {
      @if (a.summary) {
        <p class="text-muted">{{ a.summary }}</p>
      }
      <div class="help-md-body" [innerHTML]="bodyHtml()"></div>

      @if (a.documents?.length) {
        <hr>
        <h6 class="text-muted text-uppercase small">Capturas</h6>
        <div class="d-flex flex-column gap-2">
          @for (doc of a.documents; track doc.uuid) {
            @if (viewUrl(doc); as url) {
              <a [href]="url" target="_blank" rel="noopener" class="small">
                <i class="fas fa-paperclip me-1"></i>
                {{ doc.caption || doc.document?.fileName || 'Adjunto' }}
              </a>
            }
          }
        </div>
      }

      @if (canManageHelp()) {
        <hr>
        <a class="btn btn-sm btn-link px-0" routerLink="/configuracion/ayuda" (click)="offcanvas.dismiss()">
          Editar en mantenedor
        </a>
      }
    }
  </div>
</ng-template>
